// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import * as initializers from './initializers/*.js'

/* eslint-disable no-new */
export default new Vue({
	el: '#app',
	router: initializers.router,
	store,
	template: '<App/>',
	components: { App },
	mq: {
		mobile: '(max-width: 767px)',
		desktop: '(min-width: 850px)'
	}
})



// WEBPACK FOOTER //
// ./src/main.js